// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2T6zA","item":"PaymentsMobile_item__jeH-R","label":"PaymentsMobile_label__2SGMM","amount":"PaymentsMobile_amount__2zkt9"};